module.exports = __webpack_public_path__ + "static/media/new-message.04f5e8cc.mp3";